import { render, staticRenderFns } from "./my-cash.vue?vue&type=template&id=1455f2cf&scoped=true&"
import script from "./my-cash.vue?vue&type=script&lang=js&"
export * from "./my-cash.vue?vue&type=script&lang=js&"
import style0 from "./my-cash.vue?vue&type=style&index=0&id=1455f2cf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1455f2cf",
  null
  
)

export default component.exports